import { create } from 'zustand';
import { appendTick, type Tick } from './tickModel';

interface TickHistoryState {
  bySymbol: Record<string, Tick[]>;
}

/**
 * Every symbol's recent ticks, kept here instead of inside any one tick-chart component. Quotes keep being recorded
 * as long as they keep arriving (which they do whenever the symbol is watched anywhere — Market Watch, a chart, …),
 * regardless of whether a tick chart is open to show them. So reopening one picks up the running history instead of
 * starting empty again.
 */
export const useTickHistory = create<TickHistoryState>(() => ({ bySymbol: {} }));

/** Records one tick for `symbol`; a repeat of the last one, or an older one, is dropped (same rule as the chart itself). */
export function recordTick(symbol: string, tick: Tick): void {
  useTickHistory.setState((s) => {
    const list = s.bySymbol[symbol] ?? [];
    const next = appendTick(list, tick);
    return next === list ? s : { bySymbol: { ...s.bySymbol, [symbol]: next } };
  });
}
